import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';

export function* connectToPhoneBridgeSaga() {
  yield call(SignalingSocket.send, { event: 'connectToPhoneBridge' });
}
